<template src="./template.html"></template>
<script>
import moment from 'moment'

import eventService from 'api/event'
import EventCard1 from 'components/EventCard1'
import EventCard2 from 'components/EventCard2'
import EventCard3 from 'components/EventCard3'
import dateUtils from 'utils/dateUtils'
import analyticsLib from 'lib/analytics'
import TRACKING_EVENTS from 'constants/trackingEvents'

export default {
  name: 'event-list',
  props: {
    venueId: {
      type: String,
      required: true,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
    buttonText: {
      type: String,
      default: 'View Event',
    },
    buttonBgColor: {
      type: String,
    },
    buttonTextColor: {
      type: String,
    },
    eventCount: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      eventDisplayType: 'type-3',
      eventDirection: 'vertical',
      events: [],
      totalEvents: 0,
      pageSize: this.eventCount || 10,
      pageNumber: 1,
      loading: false,
    }
  },
  components: {
    EventCard1,
    EventCard2,
    EventCard3,
  },
  computed: {
    pagingStr() {
      const skip = (this.pageNumber - 1) * this.pageSize

      let topRange = skip + this.pageSize

      if (topRange > this.totalEvents) {
        topRange = this.totalEvents
      }

      return `${skip + 1} to ${topRange}`
    },
  },
  methods: {
    onIframeBlurred() {},
    onEventClick(event) {
      this.$emit('eventClicked', event)

      analyticsLib.trackEvent(TRACKING_EVENTS.ViewedEvent, {
        venueId: event.venue.id,
        venueName: event.venue.name,
        eventId: event.id,
      })
    },
    resetPaging() {
      this.pageNumber = 1
    },
    onPreviousPage() {
      this.pageNumber = this.pageNumber - 1

      return this.getData(true)
    },
    onNextPage() {
      this.pageNumber = this.pageNumber + 1

      return this.getData(true)
    },
    getData(page) {
      if (!page) {
        this.resetPaging()
      }

      this.loading = true

      const now = moment()
      // if it is before 6AM lets go back a day incase a venue is looking after midnight
      if (now.hours() < 6) now.subtract(1, 'day')

      return eventService
        .listByVenueId(this.venueId, {
          dateStart: dateUtils.toUTCTimestampWithoutTime(now),
          sort: 'date dateStart',
          skip: (this.pageNumber - 1) * this.pageSize,
          limit: this.pageSize,
          fields: ['_id', 'name', 'date', 'dateStart', 'dateEnd', 'venue(_id, name, location)', 'images', 'headerImage', 'details', 'seoPathname', 'description'].join(','),
        })
        .then((result) => {
          this.loading = false

          this.events = result.data
          this.totalEvents = result.count
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  created() {
    return this.getData()
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventList/index.vue